import React from 'react';
import PropTypes from 'prop-types';
import Input from '../material/Input';

class FormInput extends React.Component {

  static propTypes = {
    input: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    hint: PropTypes.string,
    label: PropTypes.string,
    fullWidth: PropTypes.bool,
  };

  render() {
    const {input, meta: {error, dirty, touched}, ...restProps} = this.props;
    const errorText = dirty || touched ? error : '';
    return <Input {...restProps} {...input} error={errorText} />;
  }

}

export default FormInput;



// WEBPACK FOOTER //
// ./src/components/common/material-form/Input.js